import { NOTIFICATION_CONFIG, NOTIFICATION_CONFIG_DATA, NOTIFICATION_CONFIG_END, NOTIFICATION_CONFIG_START, NOTIFICATION_CONFIG_GETBY, NOTIFICATION_CONFIG_CREATE, NOTIFICATION_CONFIG_UPDATE, NOTIFICATION_CONFIG_DELETE } from "../type";
import { validateToken, redirectToLogin } from '../../../utils/auth/tokenValidation';
import { getDecodedToken } from '../../../utils/auths';

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

type Dispatch = (action: Action) => void;


const API_URL = process.env.REACT_APP_API_URL
const loginToken = localStorage.getItem('loginToken')


export const getAllRole = (page: number, size: number) => async (dispatch: Dispatch): Promise<any> => {

  if (!validateToken()) {
    redirectToLogin();
    return;
  }

  try {
    dispatch({
      type: NOTIFICATION_CONFIG_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const institutionId = getDecodedToken()?.institutionId;
    const baseUrl = `${API_URL}/user-configuration/getAll/${page}/${size}`;
    const url = institutionId ? `${baseUrl}?institutionId=${institutionId}` : baseUrl;

    const response = await fetch(url,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: NOTIFICATION_CONFIG_DATA,
        payload: [{ res }],
        loading: false,
      });
    } else {
      const res = await response.json();
      dispatch({
        type: NOTIFICATION_CONFIG_END,
        payload: [{ res }],
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_CONFIG_END,
      payload: false,
      loading: false,
    });
    console.error(error);
  }
};

export const getConfigById = (id: number) => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return;
  }

  try {
    dispatch({
      type: NOTIFICATION_CONFIG_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/user-configuration/get/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: NOTIFICATION_CONFIG_GETBY,
        payload: res,
        loading: false,
      });
    } else {
      const res = await response.json();
      dispatch({
        type: NOTIFICATION_CONFIG_END,
        payload: [{ res }],
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_CONFIG_END,
      payload: false,
      loading: false,
    });
    console.error(error);
  }
};

export const createConfig = (data: any) => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return;
  }

  try {
    dispatch({
      type: NOTIFICATION_CONFIG_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/user-configuration/create`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      }
    );
    
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: NOTIFICATION_CONFIG_CREATE,
        payload: [{ res }],
        loading: false,
      });
    } else {
      const res = await response.json();
      dispatch({
        type: NOTIFICATION_CONFIG_END,
        payload: [{ res }],
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_CONFIG_END,
      payload: false,
      loading: false,
    });
    console.error(error);
  }
};

export const updateConfig = (id: number, data: any) => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return;
  }

  try {
    dispatch({
      type: NOTIFICATION_CONFIG_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/user-configuration/update/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      }
    );
    
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: NOTIFICATION_CONFIG_UPDATE,
        payload: [{ res }],
        loading: false,
      });
      return { success: true, data: res };
    } else {
      const res = await response.json();
      dispatch({
        type: NOTIFICATION_CONFIG_END,
        payload: [{ res }],
        loading: false,
      });
      return { success: false, message: res.message };
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_CONFIG_END,
      payload: false,
      loading: false,
    });
    console.error(error);
    return { success: false, message: 'Update failed' };
  }
};

export const deleteConfig = (id: number) => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return;
  }

  try {
    dispatch({
      type: NOTIFICATION_CONFIG_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/user-configuration/delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: NOTIFICATION_CONFIG_DELETE,
        payload: [{ res }],
        loading: false,
      });
      return { success: true, data: res };
    } else {
      const res = await response.json();
      dispatch({
        type: NOTIFICATION_CONFIG_END,
        payload: [{ res }],
        loading: false,
      });
      return { success: false, message: res.message };
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_CONFIG_END,
      payload: false,
      loading: false,
    });
    console.error(error);
    return { success: false, message: 'Delete failed' };
  }
};





